import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, DependentTableNames, PARTS_AND_LABOURS, EXPORT_FILE_NAME } from './constants';

export class ServiceOrderHistoryProvider extends BaseApi {
	async GetServiceOrderHistory(VINOrRegistrationNumber: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetServiceOrderHistory?filterVinOrRegistration=${VINOrRegistrationNumber}`);
	}

	async GetPartLaborDetailsByServiceHistoryId(serviceHistoryId:any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPartsAndLabourForServiceOrderHistory?serviceHistoryId=${serviceHistoryId}`);
	}

	async GetFullServiceOrderReports(VINOrRegistrationNumber:any, WithPdi:boolean, ColumnSeq:any) {
		// eslint-disable-next-line max-len
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetFullServiceOrderReports?filterVinOrRegistration=${VINOrRegistrationNumber}&WithPdi=${WithPdi}&ColumnSeq=${ColumnSeq}`, EXPORT_FILE_NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PARTS_AND_LABOURS:
				return `/${this.area}/${NAME}/PartsAndLaboursSchema`;

			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PARTS_AND_LABOURS:
				return `/${this.area}/${NAME}/PartsAndLaboursRows`;

			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	partsAndLabourRows(filter: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/PartsAndLaboursRows`, filter);
	}

	getServiceHistoryReport(registrationNumber: string | null, WithPdi:boolean) {
		return this.fetchPdf(`/Administration/Reports/GetServiceOrderHistoryReport?registrationNumber=${registrationNumber}&WithPdi=${WithPdi}`);
	}
}

export const apiProvider = new ServiceOrderHistoryProvider(DMS_MODULE, NAME);
